import { DefaultBtn } from "../DefaultBtn/DefaultBtn";
import { Button } from "@aidron/aidron-ds";
import { i18n } from "../../../../translate/i18n";

const { t } = i18n;

export const PrefixesBtn = ({ actions, uiState }) => {

  const { 
    setShowInputs, 
    setShowCancelModal, 
    onInputsSave, 
    setShowFormModal 
  } = actions || {};

  const { showInputs, customDisabledCondition } = uiState || {};

  return (
    <div style={{ display: 'flex', gap: '1rem' }}>
      <DefaultBtn 
        actions={{
            setShowInputs: setShowInputs,
            setShowCancelModal: setShowCancelModal,
            onInputsSave: onInputsSave
        }}
        uiState={{ showInputs: showInputs, customDisabledCondition: customDisabledCondition }}
      />

      <Button onClick={() => setShowFormModal(true)} label={t("addPrefixOfMeasure")} type="outlined" />
    </div>
  );    
}